<!-- Hors de tout @if : l'en-tête lit son menu dès le premier rendu (#1083). -->
<app-association-membre-activites-popup></app-association-membre-activites-popup>

@if (!readonly) {
  <!-- En-tête de page (#1082, #1083) : indicateur de modifications, enregistrement, menu « Autres actions ». -->
  <ng-template appEnteteActions>
    <app-etat-saisie [form]="form" />
    <button type="button" class="btn btn-primary position-relative" [disabled]="!form.dirty || saving" (click)="save()">
      @if (saving) {
        <app-button-spinner></app-button-spinner>
      }
      Enregistrer
    </button>
    <button type="button" class="btn btn-outline-primary" [cdkMenuTriggerFor]="popupBarAssociationMembreActivites.menu">
      Autres actions
      <i class="material-icons md-18" aria-hidden="true">arrow_drop_down</i>
    </button>
  </ng-template>

  <div [formGroup]="form" class="fiche">
    <app-fiche-bandeau [etat]="editor.erreursFiche" />

    <app-bloc titre="Membre">
      <div class="fiche-grille">
        <app-control codeLabel="membre" class="l2">
          <ng-select
            #select
            [items]="membreSearchor.buffer"
            [virtualScroll]="true"
            [loading]="membreSearchor.loading"
            bindLabel="label"
            [typeahead]="membreSearchor.input$"
            (scroll)="membreSearchor.onScroll($event)"
            placeholder="Sélectionner un membre"
            formControlName="id"
            bindValue="id"
            (change)="onMembreChange()"
          >
          </ng-select>
        </app-control>
      </div>
    </app-bloc>

    <app-bloc titre="Activités associées au membre">
      <div class="fiche-bloc-corps">
        <app-list
          [readOnly]="readonly"
          formControlName="membreActiviteList"
          [newElement]="newAssoDto"
          [eltName]="'Activité'"
          [nbEltsMax]="30"
          [resume]="resumeAsso"
          [consigne]="consigne"
          [deal]="activiteDeal"
          [avecCard]="false"
          [collapsible]="false"
          [pushDisabled]="!form.valid"
          [eltNonSupprimable]="assoNonSupprimable"
          (tryToDelete)="alertAssoNonSupprimable()"
        >
          <ng-template let-ctrl="ctrl" let-new="new" let-idx="idx">
            <app-saisie-membre-activite
              [formControl]="ctrl"
              [readOnly]="readonly"
              [consigne]="consigne"
              [deplie]="new"
              [membreDonne]="true"
              [activiteExclusion]="activiteAssocieeList"
            ></app-saisie-membre-activite>
          </ng-template>
        </app-list>
      </div>
    </app-bloc>
  </div>
} @else {
  rien à voir
}
